'use client';
import { useState } from 'react';

import { ArrowDown } from '../../../../public/Images';

import FromToSelect from '@/components/shared/from-to-select/from-to-select.component';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation, useWindowDimensions } from '@/hook';
import { FilterDisplayItemData } from '@/types';

import Image from 'next/image';
import { TFilterGroupFromToProps } from '@/components/filtersV2/filter-group/filter-group.component.types';

const FilterGroupFromTo = ({
    data,
    filterType,
    label,
    rangeChanged,
    range,
}: TFilterGroupFromToProps) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(true);
    const { IS_DESKTOP } = useWindowDimensions();

    const yearfromToValueChenged = (value: number[]) => {
        if (rangeChanged) {
            rangeChanged(value);
        }
    };

    return (
        <div
            className="w-full py-3 overflow-y-auto overflow-x-hidden"
            style={{
                position: 'relative',
                paddingBottom: filterType === 'fromTo' ? 0 : '',
                padding: IS_DESKTOP ? '' : 0,
                overflowX: IS_DESKTOP ? 'hidden' : 'inherit',
            }}
        >
            <div className="flex items-center justify-between mb-5">
                <Typography className="text-gray-700" variant={'captionMedium'}>
                    {label}
                </Typography>
                {IS_DESKTOP && (
                    <Image
                        src={ArrowDown.src}
                        width={18}
                        height={18}
                        alt="Toggle dropdown"
                        onClickCapture={() => setIsOpen(!isOpen)}
                        style={{
                            width: '16px',
                            transform: isOpen ? 'scaleY(-1)' : 'scaleY(1)',
                            cursor: 'pointer',
                        }}
                    />
                )}
            </div>

            {filterType === 'fromTo' && (
                <div
                    style={{
                        height: IS_DESKTOP ? '188px' : '400px',
                        display: isOpen ? 'block' : 'none',
                        paddingBottom: 0,
                        transition: 'height ease-out 0.5s',
                    }}
                    className="overflow-auto"
                >
                    {range && (
                        <FromToSelect
                            fromToValues={range}
                            data={data as FilterDisplayItemData[]}
                            placeHolder={t('Select Year')}
                            fromToValueChnaged={yearfromToValueChenged}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default FilterGroupFromTo;
